import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

const MESSAGES = {
  currentPasswordIncorrect: 'Your current password is not right.',
  passwordUnchanged: 'Choose a password that is different from your current one.',
};

const Account = () => {
  const [me, setMe] = useState(null);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState({ ok: '', err: '' });
  const [busy, setBusy] = useState(false);

  useEffect(() => { api('/auth/me', { auth: true }).then((r) => setMe(r.data)).catch(() => {}); }, []);

  const tooShort = next.length > 0 && next.length < 12;
  const mismatch = confirm.length > 0 && confirm !== next;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg({ ok: '', err: '' });
    try {
      await api('/auth/change-password', { method: 'POST', auth: true, body: { currentPassword: current, newPassword: next } });
      setCurrent(''); setNext(''); setConfirm('');
      setMsg({ ok: 'Password changed.', err: '' });
    } catch (err) {
      setMsg({ ok: '', err: MESSAGES[err.code] || err.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md">
      <h1 className="text-2xl font-bold">Account</h1>
      {me && <p className="mt-1 text-sm text-muted">Signed in as {me.fullName || me.email} ({me.email}).</p>}

      <form onSubmit={submit} className="wc-card mt-6 space-y-4 p-5">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-primary">Change password</h2>
        <div>
          <label className="wc-label" htmlFor="cur">Current password</label>
          <input id="cur" type="password" className="wc-input" value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" required />
        </div>
        <div>
          <label className="wc-label" htmlFor="new">New password</label>
          <input id="new" type="password" className="wc-input" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" required />
          <p className={`mt-1 text-xs ${tooShort ? 'text-danger' : 'text-muted'}`}>At least 12 characters.</p>
        </div>
        <div>
          <label className="wc-label" htmlFor="conf">New password again</label>
          <input id="conf" type="password" className="wc-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required />
          {mismatch && <p className="mt-1 text-xs text-danger">The two new passwords don't match.</p>}
        </div>
        {msg.ok && <p className="rounded-lg bg-success-soft p-3 text-sm text-success">{msg.ok}</p>}
        {msg.err && <p className="rounded-lg bg-danger-soft p-3 text-sm text-danger">{msg.err}</p>}
        <button type="submit" className="wc-btn-primary" disabled={busy || tooShort || mismatch || !current || !next || !confirm}>
          {busy ? 'Saving…' : 'Change password'}
        </button>
      </form>
    </div>
  );
};

export default Account;
